import i18n from '@/langs/i18n'
import {extend} from "vee-validate";
import {required, email, min, max, confirmed, required_if} from "vee-validate/dist/rules";

extend('required', {
  ...required,
  message: (_, values) => i18n.tc('validation.required')
});

extend('email', {
  ...email,
  message: (_, values) => i18n.tc('validation.email')
});

extend('min', {
  ...min,
  message: (field, values) => i18n.tc('validation.min', 0, {min: values.length, field: field})
});

extend('max', {
  ...max,
  message: (field, values) => i18n.tc('validation.max', 0, {max: values.length, field: field})
});

extend('confirmed_password', {
  ...confirmed,
  message: (field, values) => i18n.tc('validation.confirmed_password', 0, {max: values.length, field: field})
});

extend('required_if', {
  ...required_if,
  message: (field, values) => i18n.tc('validation.required_if', 0, {max: values.length, field: field})
});
